import { RolType } from "../types/types";

export const constants = {
    ROL_ADMIN : 'Administrador' as RolType,
    ROL_USER : 'Empleado' as RolType,
    ROL_EMPRESA : 'Empresa' as RolType,
    ROL_INDEPENDIENTE : 'Independiente' as RolType,
}